import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }

export function render(_ctx, _cache) {
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_v_btn = _resolveComponent("v-btn")
  const _component_v_form = _resolveComponent("v-form")
  const _component_BaseDialog = _resolveComponent("BaseDialog")
  const _component_AuthCard = _resolveComponent("AuthCard")

  return (_openBlock(), _createBlock(_component_AuthCard, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, {
        ref: "form",
        onSubmit: _withModifiers(_ctx.submit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            "validate-on": "blur",
            label: _ctx.emailData.label,
            rules: _ctx.emailData.rules,
            modelValue: _ctx.email,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.email) = $event))
          }, null, 8, ["label", "rules", "modelValue"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_btn, {
              type: "submit",
              variant: "flat",
              tile: "",
              color: "primary",
              loading: _ctx.loading
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode(" Request password reset ", -1)
              ]))]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_v_btn, {
              variant: "text",
              onClick: _ctx.goToLoginPage
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode(" Back to login ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      _createVNode(_component_BaseDialog, {
        label: "Information",
        width: 300,
        modelValue: _ctx.informationDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.informationDialog) = $event))
      }, {
        default: _withCtx(() => [
          _cache[5] || (_cache[5] = _createElementVNode("p", null, " If a user with that email-address exists, an email containing the next step will be sent to it. ", -1)),
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            tile: "",
            onClick: _ctx.goToLoginPage
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode(" Back to login ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}